var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.755,
    height: 21.891,
    viewBox: "0 0 26.755 21.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177,666.658a.4.4,0,0,1,.015-.121.4.4,0,0,1,.111-.183,10.52,10.52,0,0,1,5.9-3.35.405.405,0,0,1,.462.4v5.261a29.394,29.394,0,0,0,13.783,0v-5.261a.405.405,0,0,1,.463-.4,10.675,10.675,0,0,1,5.9,3.349.4.4,0,0,1,.128.305v14.584a.407.407,0,0,1-.207.354,27.972,27.972,0,0,1-26.342,0,.407.407,0,0,1-.207-.354Zm25.944.673a28.11,28.11,0,0,1-25.133,0V681a27.207,27.207,0,0,0,25.133,0Zm-.275-.778a9.943,9.943,0,0,0-4.589-2.663v4.552a24.156,24.156,0,0,0,4.55-1.862Zm-24.543.028a24.156,24.156,0,0,0,4.55,1.862v-4.554a9.763,9.763,0,0,0-4.592,2.662Zm14.5,9.029a.405.405,0,0,1,.518.137l2.432,3.648a.405.405,0,0,1-.337.63h-9.729a.405.405,0,0,1-.362-.587l2.432-4.865a.4.4,0,0,1,.649-.105l2.226,2.225Zm-6.46,3.605h8.316l-1.813-2.721-2.112,1.056a.405.405,0,0,1-.468-.076l-2.035-2.035Zm6.641-5.27a.811.811,0,1,1,.811-.811A.811.811,0,0,1,192.81,673.945Z",
    transform: "translate(-177 -663)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualai);
export default __webpack_public_path__ + "static/media/visualai.df08f411.svg";
export { ForwardRef as ReactComponent };